import axios from 'axios';
import { logout } from '../../authentication/authentication';
import { appConfig } from '../../../config';

const URL = appConfig.f2fHost || 'http://localhost:9060';
const BASE_URL = `${URL}api/`;

// Response Interceptors
axios.interceptors.response.use(
  (response) => response,
  function (error) {
    if (error?.response?.status === 401) {
      logout();
    }
    return Promise.reject(error);
  },
);

const isInvalidToken = (data) => {
  const { success, error_code } = data;
  return !success && (error_code === 1002 || error_code === 1003);
};

export default {
  postMethod: async (action, data, configs = {}) => {
    const jwtToken = localStorage.getItem('jwtToken') || '';
    const url = BASE_URL + action;
    if (!configs.headers)
      configs = { ...configs, headers: { Authorization: `Bearer ${jwtToken}` } };

    const result = await axios.post(url, data, configs);
    if (isInvalidToken(result.data)) {
      logout();
    }
    return result;
  },

  deleteMethod: async (action, configs = {}) => {
    const jwtToken = localStorage.getItem('jwtToken') || '';
    const url = BASE_URL + action;
    if (!configs.headers)
      configs = { ...configs, headers: { Authorization: `Bearer ${jwtToken}` } };
    const result = await axios.delete(url, configs);
    return result;
  },

  getMethod: async (action, configs = {}) => {
    const jwtToken = localStorage.getItem('jwtToken') || '';

    const url = BASE_URL + action;
    if (!configs.headers) {
      configs = { ...configs, headers: { Authorization: `Bearer ${jwtToken}` } };
    }
    const result = await axios.get(url, configs);
    if (isInvalidToken(result.data)) {
      logout();
    }
    return result;
  },
};
